module.exports = __webpack_public_path__ + "zvetseni-prsou_20_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_20_after.jpg
// module id = 1313
// module chunks = 0